module.exports = __webpack_public_path__ + "img/georgetown-logo.10f5d21.png";